import type { RouteObject } from "react-router";

/** Routes under /t/:chain/:token owned by the family slice (lazy, see overview_tape/routes). */
export const familyRoutes: RouteObject[] = [
  { path: "family/:address", lazy: async () => ({ Component: (await import("./FamilyView")).default }) },
];
